import { listStoreLenses } from 'root/src/client/logic/list/lenses'

const { viewAllPage } = listStoreLenses

export default (state, { moduleId }) => viewAllPage(moduleId, state)
